import React, { FC } from 'react'
import GridCardItem from './GridCardItem'
import { ISectionGridCardsProps } from './types'

const getGridColsClass = (length: number) => {
  if (length === 1) return 'grid-cols-1'
  return 'grid-cols-1 md:grid-cols-2'
}

export const SectionGridCards: FC<ISectionGridCardsProps> = ({
  items,
  hideMarker,
  textSize,
  centerText,
  disableHoverOnMobile,
  disableHover,
  center = false,
  className = '',
}) => {
  if (!items || items.length === 0) return null

  const gridCols = getGridColsClass(items.length)
  const alignClass = center ? 'text-center' : 'text-start'

  return (
    <div className={`w-full ${className}`}>
      <ul className={`grid ${gridCols} gap-6 md:gap-8 font-palanquin tracking-base ${alignClass}`}>
        {items.map((item, index) => (
          <GridCardItem
            key={index}
            item={typeof item === 'string' ? item : item.title}
            hideMarker={hideMarker}
            textSize={textSize}
            centerText={centerText}
            disableHoverOnMobile={disableHoverOnMobile}
            disableHover={disableHover}
          />
        ))}
      </ul>
    </div>
  )
}

export default SectionGridCards
